export const config = {
  title: "Spotless Mobile Details",
  meta: {
    description:
      "Spotless Mobile Details is a fully insured mobile auto detailing service delivering Express, Deep Glow, and Ultimate Spotless packages across the San Francisco Bay Area.",
    keywords: [
      "Bay Area mobile detailing",
      "car detailing San Francisco",
      "auto detail Oakland",
      "ceramic seal San Jose",
      "steam disinfect",
      "upholstery extraction",
      "engine bay detail",
      "Spotless Mobile Details"
    ],
    author: "Spotless Mobile Details",
    canonicalUrl: "https://www.spotlessmobiledetails.com/",
  },
  sections: {
    header: {
      businessName: "Spotless Mobile Details",
    },
    sectionB: {
      heroTitle: "Spotless Mobile Details",
      heroSubtitle: "Premium Mobile Auto Detailing Across the Bay Area",
      learnAboutText: "Book Now",
      phoneNumber: "4159401083",
      phoneLabel: "(415) 940-1083",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1151363060/photo/man-asian-inspection-and-cleaning-equipment-car-wash-with-red-car-for-cleaning-to-quality-to.jpg?s=612x612&w=0&k=20&c=E6GZxk7NFkcwhXPynE_qA-joVWHQr9YQ-dGVhCS1-mM=",
      cardData: [
        {
          title: "Express Clean",
          description:
            "Hand wash, foam soak, wheels, light interior vacuum, wipe‑down, and windows — quick upkeep at a great value.",
        },
        {
          title: "Deep Glow",
          description:
            "Full interior vacuum, detailed wipe‑down, door jambs, foam wash, and a light polish for extra gloss.",
        },
        {
          title: "Ultimate Spotless",
          description:
            "Deep inside & out with clay bar, ceramic seal, and full steam disinfecting for showroom‑level results.",
        },
      ],
      description:
        "Convenient, on‑site detailing brought to your driveway anywhere in the Bay Area — from San Francisco to Oakland and San Jose. Fully insured and trusted by repeat clients.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Choose a detailing package or customize with add‑ons to match your vehicle’s needs.",
      cards: [
        {
          title: "Express Clean — Basic In & Out",
          description:
            "Hand wash, foam soak, wheels, light interior vacuum, wipe‑down, and windows. Ideal for regular maintenance.",
          imageSrc:
            "https://media.istockphoto.com/id/1080304620/photo/close-up-of-a-modern-luxury-car-wheels.jpg?s=612x612&w=0&k=20&c=AxSHIjHFd0njmpnwchKwxd6KQ8azoEE0zmdG9Jn0lEM=",
          imageAlt: "Express exterior and interior quick clean",
        },
        {
          title: "Deep Glow — Enhanced In & Out",
          description:
            "Full interior vacuum, detailed wipe‑down, door jambs, foam wash, and a light polish for added shine.",
          imageSrc:
            "https://media.istockphoto.com/id/518118726/photo/sunday-car-wash.jpg?s=612x612&w=0&k=20&c=eFGUo3mVpnn3XJBxebRWUs7x2weZK0EuyBj3aiR5tNQ=",
          imageAlt: "Detailing with added polish and interior care",
        },
        {
          title: "Ultimate Spotless — Clay & Seal",
          description:
            "Clay bar decontamination plus ceramic seal and full steam disinfecting for maximum gloss and protection.",
          imageSrc:
            "https://media.istockphoto.com/id/2199591202/photo/car-polishing-and-detailing.jpg?s=612x612&w=0&k=20&c=pdiU1jWqXn8305y6-G-ZYJ9ZcQaGN35Sv5GJjm8gTJg=",
          imageAlt: "Showroom-level finish with ceramic protection",
        },
      ],
      otherServicesTitle: "Add‑On Services",
      otherServicesList: [
        "Upholstery Extraction",
        "Steam & Disinfect (high‑touch areas)",
        "Trunk Detail (with optional floor design)",
        "Engine Bay Detail",
      ],
    },
    sectionD: {
      aboutTitle: "About Spotless Mobile Details",
      aboutImage: {
        src:
          "https://media.istockphoto.com/id/157594719/photo/modern-car-seats.jpg?s=612x612&w=0&k=20&c=FJbksIO_Rw5ZKfuXYahrHA_adK_47dSHYXMdXjt3gNs=",
        alt: "Mobile detailing service at a client’s driveway",
      },
      aboutText: [
        "Spotless Mobile Details is a Bay Area mobile detailing company delivering high‑quality finishes with flexible, on‑site service.",
        "We’re fully insured and operate as an LLC, serving car owners and enthusiasts across the region with dependable, professional care.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Spotless Mobile Details Logo",
      businessName: "Spotless Mobile Details",
      contact: {
        phone: "4159401083",
        phoneLabel: "(415) 940-1083",
        email: "khanouf1234@gmail.com",
        website: "https://www.spotlessmobiledetails.com/",
        address: "San Francisco Bay Area, CA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "San Francisco Bay Area, California",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d252069.04822194708!2d-122.5321208!3d37.7576948!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808f7e2a0f9a4e19%3A0xa2c3b6e!2sSan%20Francisco%20Bay%20Area!5e0!3m2!1sen!2sus!4v1710000000000!5m2!1sen!2sus",
    },
  },
};

export default config;
